import Resource from '@/api/resource'
import request from '@/utils/request'

class SurveyMethods extends Resource {
  constructor() {
    super('survey-methods')
  }

  /**
     * Get all active survey methods
     * @returns {Promise} API response with list of survey methods
     */
  list() {
    return request({
      url: `/${this.uri}/list`,
      method: 'get',
    })
  }
}

export { SurveyMethods as default }
